import { getOptionValue, namedToOptionDeleted } from 'services/helpers';

import {
  setDelayAmount,
  checkDeleted,
  nameDescriptor,
} from 'pages/AutomationEngine/helpers';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { formId, delayAmount } = orgDetails;
  return {
    stepGoal: {
      ...orgDetails,
      delayAmount: setDelayAmount(delayAmount),
      triggers: [
        {
          type: AUTOMATION_STEPS.form_submitted.type,
          triggerFormSubmitted: {
            formId: getOptionValue(formId),
          },
        },
      ],
    },
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const { form } = firstTrigger.triggerFormSubmitted || {
    form: { id: null, label: null },
  };

  const formId = namedToOptionDeleted(form);

  const type = AUTOMATION_STEPS.form_submitted_goal.type;

  if (!firstTrigger.triggerFormSubmitted) {
    // missingtrigger, after import
    addErrorMessage(messageDictionary.automationFailedToLoad);
  } else {
    checkDeleted(messageDictionary, addErrorMessage, form, nameDescriptor);
  }
  return { formId, type };
};

export const formSubmittedGoalDTO = {
  forApi,
  forFlow,
};
